import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';
import LegalPageLayoutV2 from '@/components/marketing/legal/v2/LegalPageLayoutV2';

export default function Privacy() {
  const { t } = useTranslation('marketing');

  return (
    <>
      <SEOHead
        title="Politique de confidentialité — Velko POS"
        description="Politique de confidentialité Velko POS : ce que nous collectons, pourquoi, pendant combien de temps, et vos droits (RGPD · OHADA)."
        path="/politique-confidentialite"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Confidentialité', path: '/politique-confidentialite' },
        ]}
      />
      <LegalPageLayoutV2
        kind="privacy"
        subtitle={t('privacy.heroSubtitle')}
        lastUpdated={t('privacy.lastUpdated')}
        content={t('privacy.content')}
        contactTitle="Exercer un droit sur vos données ?"
        contactDesc="Demande d'accès, rectification, suppression ou portabilité : on te répond en moins de 30 jours. Objet email : « Droit RGPD »."
      />
    </>
  );
}
